<template>
  <div v-if="hasDocuments">
    <section-title
      class="mt-5"
      content="Documentos Relacionados"
      :has-line="true"
    />

    <div
      v-for="(contract, index) in relatedContracts"
      :key="`previous-version-index-${index}`"
    >
      <custom-callout
        class-main="mt-3 rounded"
        :has-border="false"
        :has-toggle="true"
      >
        <div class="row py-2 align-items-center">
          <div class="col-2 mt-3 mt-md-0">
            <div class="color-gray-6 font-14">Contrato:</div>
            <div class="color-black font-16">
              {{ contract.contractNumber }}
            </div>
          </div>

          <div class="col-2 mt-3 mt-md-0">
            <div class="color-gray-6 font-14">Fecha Enmienda:</div>
            <div class="color-black font-16">
              {{ contract.amendmentDate | date('DD/MM/YYYY') }}
            </div>
          </div>
        </div>

        <template #edition>
          <div
            v-for="(document, di) in contract.documents"
            :key="`previous-version-${index}-document-index-${di}`"
          >
            <div class="row document-row align-items-center">
              <div class="col-2 mt-3 mt-md-0">
                <div class="color-gray-6 font-14">Documento:</div>
                <div class="color-black font-16">
                  {{ document.documentTypeName }}
                </div>
              </div>

              <div class="col-4 mt-3 mt-md-0">
                <div class="color-gray-6 font-14">Archivo:</div>
                <div class="color-black font-16">
                  {{ document.documentFilename }}
                </div>
              </div>

              <div
                class="col mt-3 mt-md-0 d-flex justify-content-end align-items-center"
              >
                <action-button
                  class="btn-action-size ml-2"
                  i="fas fa-file-download"
                  variant="success"
                  @click="downloadFile(document)"
                />
              </div>
            </div>
          </div>
        </template>
      </custom-callout>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';

import { downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import { getRelatedContractDocuments } from '@/services/uspqrp/contract.api.js';

export default {
  name: 'DocumentsRelated',
  components: {
    SectionTitle,
    CustomCallout,
    ActionButton,
  },
  props: {
    contractId: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  data: () => ({
    relatedContracts: [],
  }),
  computed: {
    hasDocuments() {
      return this.relatedContracts.length > 0;
    },
  },
  methods: {
    async fetchDocumentsRelated() {
      const { data } = await getRelatedContractDocuments(this.contractId);
      this.relatedContracts = data;
    },
    async downloadFile(document) {
      try {
        await downloadDocumentByAttachmentId(document.documentId);
      } catch (error) {
        this.ShowToast(
          'Alerta',
          error.response.data.message || 'Error en la descarga del archivo',
          'error'
        );
      }
    },
  },
  async mounted() {
    if (this.contractId > 0) {
      await this.fetchDocumentsRelated();
    }
  },
};
</script>

<style scoped lang="scss">
.btn-action-size {
  width: 35px;
  height: 35px;
}

.document-row {
  margin: 20px;
  padding: 10px 10px;
}
</style>
